import { Controller } from "@hotwired/stimulus"

// La campanella «segui» di una scheda del catalogo (toggleFollow di Grants.js): cambia subito (aggiornamento ottimista),
// poi POST /api/grants/:id/follow { follow }; toast dell'esito, oppure torna com'era con il toast «Errore».
// Un'icona sola nel pulsante (Bell o BellOff), presa dai template.
export default class extends Controller {
  static targets = ["on", "off"]
  static values = { url: String, following: Boolean }

  async toggle() {
    const nf = !this.followingValue
    this.mostra(nf)
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const risposta = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json", ...(token ? { "X-CSRF-Token": token } : {}) },
        body: JSON.stringify({ follow: nf }),
      })
      if (!risposta.ok) throw new Error(String(risposta.status))
      window.toast?.success(nf ? "Riceverai gli avvisi per questo bando" : "Non segui più questo bando")
    } catch (_) {
      this.mostra(!nf)
      window.toast?.error("Errore")
    }
  }

  mostra(on) {
    this.followingValue = on
    const b = this.element
    b.title = on ? "Segui avvisi: attivo" : "Segui avvisi di riapertura"
    b.classList.toggle("text-blue-600", on)
    b.classList.toggle("text-zinc-400", !on)
    b.classList.toggle("hover:text-blue-600", !on)
    const icona = (on ? this.onTarget : this.offTarget).content.firstElementChild.cloneNode(true)
    b.querySelector(":scope > svg").replaceWith(icona)
  }
}
